import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import Pdf from "./components/Pdf";
import Socket from "../../../../../socket/socket";
import Slides from "./components/Slides";
import _ from "lodash";
import { Modal, ModalBody } from "reactstrap";
import QRCode from "qrcode.react";
import closeIcon from "../../../../../assets/images/slide-kick/cross-iconn.png";
import { withRouter } from "react-router-dom";
import * as socketAction from "../../../../../redux/sockets/action";

import BottomNav from "./components/BottomNav";
import { FullScreen, useFullScreenHandle } from "react-full-screen";

const PresentingSlideKickAndHero = (props) => {
  const room_data = _.get(props, "gameReducer.roomObj");
  let link = _.get(props, "gameReducer.roomObj.branch_url");

  let slide_QR = _.get(props, "socketReducer.slide_QR");
  const slide_type = _.get(room_data, "game_state.slide_type");

  const current_slide = _.get(room_data, "game_state.current_slide");

  const hero_url = _.get(room_data, "game_state.hero_url");
  const deck_size = _.get(room_data, "game_state.deck_size");
  const [active_slide, set_active_slide] = useState(current_slide);

  const handle = useFullScreenHandle();
  let toggleSlideKickQR = () => {
    props.toggleSlideKickQR(!slide_QR);
  };
  useEffect(() => {
    set_active_slide(current_slide);
  }, [current_slide]);

  const change_slide = (offset) => {
    set_active_slide((prev_active_slide) => {
      return prev_active_slide + offset;
    });
    const data = {
      action: "change-slide",
      roomId: room_data.id,
      userId: room_data.host_user_id,
      slideAction: "goto",
      slideNumber: active_slide + offset,
    };
    Socket.sendMessage(data);
  };

  return (
    <div className="presenting-slideKick-and-hero-wrapper">
      {slide_QR === true && (
        <Modal
          className="presenting-slideKick-and-hero-modal"
          backdropClassName="presenting-slideKick-and-hero-modal-backdrop"
          isOpen={true}
          centered
        >
          <div className="scan-code-flex">
            <p className="scan-heading">Scan the Code</p>
            <button href="#" className="close-btn">
              <img src={closeIcon} onClick={toggleSlideKickQR} alt="" />
            </button>
          </div>
          <QRCode
            value={link && link !== "" ? link : "Loading"}
            // size={200}
            bgColor="transparent"
            fgColor={"#2A2A2A"}
            className="qr-code-big"
          />
        </Modal>
      )}
      {slide_type === "pdf" ? (
        <Pdf
          active_slide={active_slide}
          handle={handle}
          FullScreen={FullScreen}
          hero_url={hero_url}
        />
      ) : (
        <Slides
          active_slide={active_slide}
          handle={handle}
          FullScreen={FullScreen}
          hero_url={hero_url}
        />
      )}
      <BottomNav
        change_slide={change_slide}
        active_slide={active_slide}
        deck_size={deck_size}
        handle={handle}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  socketReducer: state.socketReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {
    toggleSlideKickQR: (data) => dispatch(socketAction.toggleSlideKickQR(data)),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(PresentingSlideKickAndHero);
